import { SystemIcon } from '@monorepo/nova-icons';
import { IconButton, useTheme } from '@monorepo/nova-ui';

type ProfileButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  active?: boolean;
};

export const ProfileButton = ({ onClick, active }: ProfileButtonProps) => {
  const { palette } = useTheme();

  return (
    <IconButton onClick={onClick} aria-label="Profile">
      <SystemIcon
        color={active ? palette.primary.main : palette.text.main}
        iconName="UserCircle"
      />
    </IconButton>
  );
};
